import Api from 'App/api'

export const getLedger = Api.get({
  controller: 'ledger',
  action: 'getLedger',
})

export const getChargeDetails = Api.get({
  controller: 'ledger',
  action: 'getChargeDetails',
})

export const getLedgerWithSettings = Api.get({
  controller: 'ledger',
  action: 'getLedgerWithSettings',
})

export const getLedgerSettings = Api.get({
  controller: 'ledger',
  action: 'getSettings',
})

export const getCustomerInvoices = Api.get({
  controller: 'customer_invoices',
  action: 'list',
})
